import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MenuIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Menu`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 13H1M15 8H1M15 3H1"
    />
  </Icon>
);
